import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class UserRoleService extends BaseService{
	constructor() {
		super('/UserRole');
	}



	public getAllByFilter(filter: UserRoleFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class UserRoleFilter extends BaseFilter{
	constructor(idUser?: number | null, idGroup?: number | null, idTenant?: number | null) {
		super();
		this._idUser = idUser;
		this._idGroup = idGroup;
		this._idTenant = idTenant;
	}

	private _idUser?: number | null;
	private _idRole?: number | null;
	private _idGroup?: number | null;
	private _idTenant?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idUser != null ? { IdUser: this._idUser } : {}),
			(this._idGroup != null ? { IdGroup: this._idGroup } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})
	
		);

		return data;
	};
}